var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"matching-results-loading"},[_c('div',{staticClass:"matching-results-loading--cards"},[_vm._t("body")],2),_vm._t("action")],2)}
var staticRenderFns = []

export { render, staticRenderFns }